import React from "react";

function Pricing() {
  return (
    <section className="section pb-0">
      <div className="container mt-10">
        <h1 className="text-center font-bold text-2xl m-2">Why Lead Lytics?</h1>
        <div className="flex flex-wrap justify-center">
          <div className="w-full sm:w-1/2 lg:w-1/4 p-4">
            <div className="bg-white rounded-lg shadow-md p-6 text-center hover:bg-blue-100 transition duration-300">
              <h2 className="text-2xl text-blue-600 font-semibold">
                Personalized Business
              </h2>
              <p className="mt-3 text-center p-2">
                Being a leading digital marketing agency we cater all businesses
                needs as per their budgets and goals. We not only welcome small
                business but make sure they thrive online on search engine,
                social media and Google & YouTube ads. Either you are start up
                or mid size business tight on budgets we will help you transform
                into a market leader with our customize packages.
              </p>
              <a
                href="/contact"
                className="btn btn-outline-primary mt-4 block text-center"
              >
                <button className="border rounded-md p-3 hover:bg-[#BAB5B5]">
                  Get Started
                </button>
              </a>
            </div>
          </div>

          <div className="w-full sm:w-1/2 lg:w-1/4 p-4">
            <div className="bg-white rounded-lg shadow-lg p-6 text-center hover:bg-stone-200 transition duration-300">
              <h2 className="text-2xl text-blue-600 font-semibold">
                Customized Approach
              </h2>
              <p className="mt-3 p-2">
                We believe in solutions that’s is why businesses we work with
                grow in their industries either local or international markets.
                Being a digital marketing company We not only help our clients
                with SEO, Social media and 360 digital marketing solutions but
                also with development and design we support WordPress,
                Woocommerce, Shopify, Custom PHP, React JS, NextJS and more.
              </p>
              <a
                href="/contact"
                className="btn btn-outline-primary mt-4 block text-center"
              >
                <button className="border rounded-md p-3 hover:bg-[#BAB5B5]">
                  Get Started
                </button>
              </a>
            </div>
          </div>

          <div className="w-full sm:w-1/2 lg:w-1/4 p-4">
            <div className="bg-white rounded-lg shadow-md p-6 text-center hover:bg-emerald-200 transition duration-300">
              <h2 className="text-2xl text-blue-600 font-semibold">
                Results-Driven Solutions
              </h2>
              <p className="mt-3 p-2">
                At LEAD LYTICS, we are committed to delivering measurable
                results for our clients. We leverage the latest technologies and
                marketing tools to create data-driven campaigns that are
                optimized for performance and ROI. Therefore, our team is
                constantly monitoring and analyzing campaign performance, making
                adjustments as needed.
              </p>
              <a
                href="/contact"
                className="btn btn-outline-primary mt-4 block text-center"
              >
                <button className="border rounded-md p-3 hover:bg-[#BAB5B5]">
                  Get Started
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Pricing;
